export default __webpack_public_path__ + "media/images/background-cybre-a554c17105df56083c135a3797b54e90.png";